module.exports = __webpack_public_path__ + "img/INR.1cc00021.svg";